import { withRouter, useHistory } from 'react-router-dom';
import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import PropTypes from 'prop-types';
import { AsyncLink } from '@jutro/router';
import { StepProgressBar, useModal } from '@jutro/components';
import messages from './FNOLWizardStepsComponent_AX.messages';
import style from './FNOLWizardStepsComponent_AX.module.scss';

function FNOLWizardStepsComponentAX(props) {
    const {
        onEnterStep1,
        onEnterStep2,
        onEnterStep3,
        currentStep,
        claimCreated
    } = props;
    const translator = useContext(TranslatorContext);
    const [visitedSteps, updateVisitedSteps] = useState([1]);
    const [steps, updateSteps] = useState([]);
    const history = useHistory();
    const {
        showConfirm
    } = useModal();
    useEffect(() => {
        updateSteps([
            {
                active: currentStep === 1,
                onClick: function onStepClicked() {
                    const canProceed = onEnterStep1();
                    if (canProceed) {
                        updateVisitedSteps([1]);
                    }
                },
                title: messages.step1Title,
                visited: visitedSteps.includes(1)
            },
            {
                active: currentStep === 2,
                onClick: function onStepClicked() {
                    const canProceed = onEnterStep2();
                    if (canProceed) {
                        updateVisitedSteps([1, 2]);
                    }
                },
                title: messages.step2Title,
                visited: visitedSteps.includes(2)
            },
            {
                active: false, // yep always false, this will show the user as successfully created
                onClick: function onStepClicked() {
                    const canProceed = onEnterStep3();
                    if (canProceed) {
                        updateVisitedSteps([1, 2, 3]);
                    }
                },
                title: messages.step3Title,
                visited: visitedSteps.includes(3)
            }
        ]);
    }, [currentStep, onEnterStep1, onEnterStep2, onEnterStep3, visitedSteps]);
    const handlerBack = useCallback(async () => {
        showConfirm({
            status: 'warning',
            icon: 'mi-warning',
            title: messages.titleAlert,
            message: messages.messageAlert,
            confirmButtonText: messages.yes,
            cancelButtonText: messages.not
        }).then((result) => {
            if (result === 'confirm') {
                history.push('/');
            }
        });
    }, [history]);
    
    function ButtonCancel(){
        return (
            <div className={style.cancelDiv}>

                <AsyncLink
                    
                    iconPosition="left"
                    message=""
                    onTrigger={handlerBack}
                    icon="mi-cancel"
                    id="backLink"
                >
                    {translator(messages.back)}
                </AsyncLink>
            </div>
            );
    }

    return (
        <>
            {
                !claimCreated && (
                    <ButtonCancel />  
                )
            }
            <StepProgressBar
                steps={steps}
                isVertical={false}
            />
        </>
    );
}

FNOLWizardStepsComponentAX.propTypes = {
    onEnterStep1: PropTypes.func,
    onEnterStep2: PropTypes.func,
    onEnterStep3: PropTypes.func
};

FNOLWizardStepsComponentAX.defaultProps = {
    onEnterStep1: _.noop,
    onEnterStep2: _.noop,
    onEnterStep3: _.noop
};

export default withRouter(FNOLWizardStepsComponentAX);
